module.exports = __webpack_public_path__ + "static/media/map2.da449b71.png";